import React, { useEffect, useState } from "react";
import DashboardNav from "./DashboardNav";
import DashboardSidebar from "./DashboardSidebar";

const DashboardLayout = ({ children, selectedMenu, setSelectedMenu }) => {
  const [isOpen, setIsOpen] = useState(window.innerWidth >= 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setIsOpen(!mobile);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const toggle = () => setIsOpen((v) => !v);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Sidebar */}
      <DashboardSidebar
        isOpen={isOpen}
        isMobile={isMobile}
        selectedMenu={selectedMenu}
        setSelectedMenu={setSelectedMenu}
        toggleSidebar={toggle}
      />

      {/* Right column */}
      <div className="flex flex-col flex-1 overflow-hidden min-w-0">
        <DashboardNav toggleSidebar={toggle} />
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>

      {/* Mobile overlay */}
      {isOpen && isMobile && (
        <div
          className="fixed inset-0 z-20 bg-black/50"
          onClick={toggle}
        />
      )}
    </div>
  );
};

export default DashboardLayout;
